import { ActionBasic } from 'kts-scaffold-framework/modules';
import { IVisitedItem } from './interface';

import ModulesState from './Modules.State';
import { setVisitedRecord } from './storage';
class ModulesAction extends ActionBasic<ModulesState> {
    setVisitedRecord = (userKey:string,visitedItem: IVisitedItem) => {
        setVisitedRecord(userKey,visitedItem,this.updateList);
    }
    updateList=(data)=>{
        this.modulesState.visitedList=data;
        this.setModulesState();
    }

}

export default new ModulesAction();


// WEBPACK FOOTER //
// ./src/display/components/RecentlyVisited/Modules.Action.ts